<svelte:head>
	<title>Subscribe — DSARC Feeds</title>
	<meta
		name="description"
		content="RSS feeds and calendar subscriptions for Do Something Amateur Radio Club."
	/>
</svelte:head>

<div class="mx-auto max-w-2xl">
	<h1 class="mb-2 text-3xl font-bold text-gray-900 dark:text-white">Subscribe</h1>
	<p class="mb-8 text-gray-600 dark:text-gray-400">
		Stay up to date with DSARC events, meeting minutes, and news using your favorite feed reader or
		calendar app.
	</p>

	<section class="mb-10">
		<h2 class="mb-4 text-xl font-semibold text-gray-800 dark:text-gray-200">RSS Feeds</h2>
		<div class="space-y-4">
			<a
				href="/rss.xml"
				class="flex items-start gap-4 rounded-lg border border-gray-200 p-4 hover:border-orange-400 hover:bg-orange-50 dark:border-gray-700 dark:hover:border-orange-500 dark:hover:bg-gray-800"
			>
				<span class="mt-0.5 text-2xl" aria-hidden="true">📡</span>
				<div>
					<p class="font-semibold text-gray-900 dark:text-white">All Updates</p>
					<p class="text-sm text-gray-600 dark:text-gray-400">
						Combined feed: events + meeting minutes
					</p>
					<p class="mt-1 font-mono text-xs text-orange-600 dark:text-orange-400">
						https://dsarc.us/rss.xml
					</p>
				</div>
			</a>

			<a
				href="/rss/events.xml"
				class="flex items-start gap-4 rounded-lg border border-gray-200 p-4 hover:border-orange-400 hover:bg-orange-50 dark:border-gray-700 dark:hover:border-orange-500 dark:hover:bg-gray-800"
			>
				<span class="mt-0.5 text-2xl" aria-hidden="true">📅</span>
				<div>
					<p class="font-semibold text-gray-900 dark:text-white">Events</p>
					<p class="text-sm text-gray-600 dark:text-gray-400">
						Field days, antenna builds, special activities, and club events
					</p>
					<p class="mt-1 font-mono text-xs text-orange-600 dark:text-orange-400">
						https://dsarc.us/rss/events.xml
					</p>
				</div>
			</a>

			<a
				href="/rss/meetings.xml"
				class="flex items-start gap-4 rounded-lg border border-gray-200 p-4 hover:border-orange-400 hover:bg-orange-50 dark:border-gray-700 dark:hover:border-orange-500 dark:hover:bg-gray-800"
			>
				<span class="mt-0.5 text-2xl" aria-hidden="true">📋</span>
				<div>
					<p class="font-semibold text-gray-900 dark:text-white">Meeting Minutes</p>
					<p class="text-sm text-gray-600 dark:text-gray-400">
						General, board, and special meeting minutes
					</p>
					<p class="mt-1 font-mono text-xs text-orange-600 dark:text-orange-400">
						https://dsarc.us/rss/meetings.xml
					</p>
				</div>
			</a>

			<a
				href="https://dsarc.substack.com/feed"
				target="_blank"
				rel="noopener noreferrer"
				class="flex items-start gap-4 rounded-lg border border-gray-200 p-4 hover:border-orange-400 hover:bg-orange-50 dark:border-gray-700 dark:hover:border-orange-500 dark:hover:bg-gray-800"
			>
				<span class="mt-0.5 text-2xl" aria-hidden="true">✉️</span>
				<div>
					<p class="font-semibold text-gray-900 dark:text-white">Newsletter (Substack RSS)</p>
					<p class="text-sm text-gray-600 dark:text-gray-400">
						Club news and articles via Substack's RSS feed
					</p>
					<p class="mt-1 font-mono text-xs text-orange-600 dark:text-orange-400">
						https://dsarc.substack.com/feed
					</p>
				</div>
			</a>
		</div>
	</section>

	<section class="mb-10">
		<h2 class="mb-4 text-xl font-semibold text-gray-800 dark:text-gray-200">Newsletter</h2>
		<a
			href="https://dsarc.substack.com"
			target="_blank"
			rel="noopener noreferrer"
			class="flex items-start gap-4 rounded-lg border border-gray-200 p-4 hover:border-blue-400 hover:bg-blue-50 dark:border-gray-700 dark:hover:border-blue-500 dark:hover:bg-gray-800"
		>
			<span class="mt-0.5 text-2xl" aria-hidden="true">✉️</span>
			<div>
				<p class="font-semibold text-gray-900 dark:text-white">DSARC on Substack</p>
				<p class="text-sm text-gray-600 dark:text-gray-400">
					Club news, articles, and announcements — delivered to your inbox
				</p>
				<p class="mt-1 font-mono text-xs text-blue-600 dark:text-blue-400">dsarc.substack.com</p>
			</div>
		</a>
	</section>

	<section>
		<h2 class="mb-4 text-xl font-semibold text-gray-800 dark:text-gray-200">Calendar</h2>
		<a
			href="/calendar"
			class="flex items-start gap-4 rounded-lg border border-gray-200 p-4 hover:border-green-400 hover:bg-green-50 dark:border-gray-700 dark:hover:border-green-500 dark:hover:bg-gray-800"
		>
			<span class="mt-0.5 text-2xl" aria-hidden="true">🗓️</span>
			<div>
				<p class="font-semibold text-gray-900 dark:text-white">Google Calendar</p>
				<p class="text-sm text-gray-600 dark:text-gray-400">
					View or subscribe to the DSARC event calendar in your calendar app
				</p>
				<p class="mt-1 font-mono text-xs text-green-600 dark:text-green-400">dsarc.us/calendar</p>
			</div>
		</a>
	</section>
</div>
